import React from 'react';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../../constants/routes';

const KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';

const CLIENTS = [
    { nm: 'Acme Holdings', tier: 'Gold', w: '84%', cls: 'gold' },
    { nm: 'Bloom & Co', tier: 'Silver', w: '61%', cls: 'silver' },
    { nm: 'Nova Ventures', tier: 'Bronze', w: '38%', cls: 'bronze' },
];

const AccountantsHeroSection = () => (
    <section className="lp-hero">
        <div className="lp-hero-glow lp-glow-anim" aria-hidden="true" />
        <div className="lp-hero-inner">
            <div className="lp-hero-copy">
                <div className="lp-badge lp-badge--up" data-lp-reveal><span />For Accountants</div>
                <h1 className="lp-h1" data-lp-reveal data-lp-delay="60">Grow your clients’<br /><span style={{ color: '#FC7785' }}>value.</span><br />Simply.</h1>
                <p className="lp-lead" data-lp-reveal data-lp-delay="120">Our platform, free to accountancy practices – helps you deliver existing corporate finance services at higher margins, more quickly at less cost and introduces dealflow to you.</p>
                <div className="lp-cta-row" data-lp-reveal data-lp-delay="180">
                    <a className="lp-btn lp-btn--primary" href={KOALENDAR} target="_blank" rel="noopener noreferrer">Book a call</a>
                    <Link className="lp-btn lp-btn--ghost" to={ROUTES.REGISTER}>Register free</Link>
                </div>
            </div>

            <div className="lp-hero-art">
                <div className="lp-acc-stage">
                    <img className="lp-acc-photo" src={require('../../../../images/landing-pages/accountants/accountant-top-banner.png')} alt="Accountant professional" />
                    <div className="lp-acc-clientcard lp-float" data-lp-reveal data-lp-delay="200">
                        <div className="cc-top">
                            <span className="t">Client health</span>
                            <span className="n">3 active</span>
                        </div>
                        {CLIENTS.map((c, i) => (
                            <div className="cc-row" key={i}>
                                <div className="cc-head">
                                    <span className="nm">{c.nm}</span>
                                    <span className={`tier ${c.cls}`}>{c.tier}</span>
                                </div>
                                <span className="track"><i className={c.cls} style={{ width: c.w }} /></span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default AccountantsHeroSection;
